import { useEffect, useState } from 'react';
import { Network } from '@capacitor/network';
import { Capacitor } from '@capacitor/core';
import { WifiOff } from 'lucide-react';

export default function OfflineIndicator() {
  const [isOnline, setIsOnline] = useState(true);

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      Network.getStatus().then(status => setIsOnline(status.connected));
      const handle = Network.addListener('networkStatusChange', status => {
        setIsOnline(status.connected);
      });
      return () => {
        handle.then(h => h.remove());
      };
    } else {
      setIsOnline(navigator.onLine);
      const on = () => setIsOnline(true);
      const off = () => setIsOnline(false);
      window.addEventListener('online', on);
      window.addEventListener('offline', off);
      return () => {
        window.removeEventListener('online', on);
        window.removeEventListener('offline', off);
      };
    }
  }, []);

  if (isOnline) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(10, 10, 15, 0.95)', backdropFilter: 'blur(10px)',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      color: 'white', padding: '24px', textAlign: 'center',
      animation: 'fadeIn 0.3s ease'
    }}>
      <div style={{
        background: 'rgba(239, 68, 68, 0.15)', border: '1px solid rgba(239, 68, 68, 0.3)',
        borderRadius: '50%', padding: '24px', marginBottom: '24px',
      }}>
        <WifiOff size={48} color="#EF4444" />
      </div>
      <h2 style={{ fontSize: '24px', fontWeight: 800, marginBottom: '8px' }}>You are Offline</h2>
      <p style={{ color: 'rgba(255, 255, 255, 0.6)', fontSize: '15px', maxWidth: '300px', marginBottom: '32px', lineHeight: '1.5' }}>
        Please check your internet connection. We will sync your data automatically once you are back online.
      </p>
      <button 
        onClick={() => {
          if (Capacitor.isNativePlatform()) {
            Network.getStatus().then(status => setIsOnline(status.connected));
          } else {
            setIsOnline(navigator.onLine);
          }
        }}
        style={{
          background: 'linear-gradient(135deg, #6C63FF 0%, #3B82F6 100%)', color: 'white', border: 'none',
          padding: '12px 32px', borderRadius: '12px', fontSize: '15px', fontWeight: 700,
          cursor: 'pointer', boxShadow: '0 4px 15px rgba(108, 99, 255, 0.4)'
        }}
      >
        Retry Connection
      </button>
    </div>
  );
}
